export interface MenuOption {
  key: string
  label: string
}

export const MENU_OPTIONS: MenuOption[] = [
  { key: 'dashboard', label: '대시보드' },
  { key: 'members', label: '회원관리' },
  { key: 'subscriptions', label: '구독관리' },
  { key: 'scores', label: '악보관리' },
  { key: 'score-logs', label: '악보로그' },
  { key: 'cognitive', label: '인지플레이' },
  { key: 'cognitive-logs', label: '인지로그' },
  { key: 'notices', label: '공지사항' },
  { key: 'settings', label: '설정' },
]

export interface RoleOption {
  value: string
  label: string
}

export const ROLE_OPTIONS: RoleOption[] = [
  { value: 'all', label: '전체 운영자' },
  { value: 'content', label: '콘텐츠 운영자' },
  { value: 'customer', label: '고객 운영자' },
  { value: 'viewer', label: '조회 전용' },
  { value: 'custom', label: '맞춤 권한' },
]

const ALL_MENU_KEYS = MENU_OPTIONS.map((menu) => menu.key)

const ROLE_MENU_PRESETS: Record<string, string[]> = {
  all: ALL_MENU_KEYS,
  content: ['scores', 'score-logs', 'cognitive', 'cognitive-logs', 'notices'],
  customer: ['members', 'subscriptions', 'notices'],
  viewer: ALL_MENU_KEYS,
  custom: [],
}

export function roleLabel(role: string): string {
  return ROLE_OPTIONS.find((option) => option.value === role)?.label ?? role
}

export function menuLabel(menuKey: string): string {
  return MENU_OPTIONS.find((menu) => menu.key === menuKey)?.label ?? menuKey
}

export function resolveAllowedMenus(role: string, allowedMenusJson: string | null): string[] {
  if (role === 'custom') {
    if (!allowedMenusJson) {
      return []
    }
    try {
      const parsed = JSON.parse(allowedMenusJson)
      return Array.isArray(parsed) ? parsed.filter((menu) => typeof menu === 'string') : []
    } catch (error) {
      return []
    }
  }
  return ROLE_MENU_PRESETS[role] ?? []
}
